import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

import {
  IAPI_ACC009_Request,
  IAPI_ACC009_Response,
  IAPI_ACC005_Request,
  IAPI_ACC005_Response,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// メールアドレス再登録届更新API
// API仕様書_アカウント管理
const httpEmailAddressReregistrationNotificationUpdate = async (
  param: IAPI_ACC009_Request
): Promise<IAPI_ACC009_Response> => {
  let res = await http.post(ApiUrl.API_ACC009, {
    ...param,
  });
  return res.data;
};

// メールアドレス再登録届参照
// API仕様書_アカウント管理
const httpAPI_ACC005 = async (
  param: IAPI_ACC005_Request
): Promise<IAPI_ACC005_Response> => {
  let res = await http.post(ApiUrl.API_ACC005, {
    ...param,
  });
  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export {
  httpEmailAddressReregistrationNotificationUpdate,
  httpAPI_ACC005,
  httpAPI_APP016,
};
